import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';

import { Typography } from 'src/app/components/Elements/Typography';

export const JustSayCapsuleSVG = styled(InlineSVG)`
  border-radius: ${props => props.theme.space.s3};
  margin: 0 auto;
  width: 27.1rem;
  height: 8.8rem;
`;

export const JustSayCapsuleText = styled(Typography)`
  color: ${props => props.theme.colors.capsuleBlue50};
  font-size: ${props => props.theme.fontSizes.body};
  font-family: ${props => props.theme.fonts.circular};
  font-weight: ${props => props.theme.fontWeights.roman};
`;
